import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import BadgeUI from '../../../../widgets/output/BadgeUI'

const RecommendationUI = ({ context, loan, loanFeasibility, feasibilityItemList,
  failed, total, failedSmallLoan, totalSmallLoan, onRefreshClick,
}) =>
  <div className='c_l_fs'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Recommendation</b></span>
        </div>
      }
      right={
        <span />
      }
    />

    <CardUI className='g_m_bottom_100'>
      <div>
        <span dangerouslySetInnerHTML={{ __html: loanFeasibility.feasibilityDescription }} />
      </div>
    </CardUI>

    <CardUI className='g_m_bottom_100'
      title={
        loan.loanFlavor !== 'small_loan' ?
          <div className='g_flex_h'>
            <span>Recommendation for classic loan</span>
            <BadgeUI label={loanFeasibility.classicLoanRecommeded ? 'Console Recommends' : 'Console Rejects'}></BadgeUI>
          </div>
          :
          <div className='g_flex_h'>
            <span>Recommendation for small loan</span>
            {
              failedSmallLoan &&
              <BadgeUI label='Console Rejects'></BadgeUI>
            }
            {
              !failedSmallLoan &&
              <BadgeUI label='Console Recommends'></BadgeUI>
            }
          </div>
      }
    >
      {
        loan.loanFlavor !== 'small_loan' ?
          <span>{failed} check{failed == 1 ? '' : 's'} failed out of {total}</span>
          :
          <span>{failedSmallLoan} check{failedSmallLoan == 1 ? '' : 's'} failed out of {totalSmallLoan}</span>
      }
      <div>
        {
          loan.loanFlavor !== 'small_loan' &&
          <LRTableBodyUI className='g_m_top_100'>
            {
              feasibilityItemList.filter(item => item.flavor === 'classic' && !item.pass && item.priority && item.recommendation).map((item, i) =>
                < RecoUI context={context} item={item} />
              )
            }
          </LRTableBodyUI>
        }
        {
          loan.loanFlavor === 'small_loan' &&
          <LRTableBodyUI className='g_m_top_100'>
            {
              feasibilityItemList.filter(item => item.flavor === 'small' && !item.pass && item.recommendation).map((item, i) =>
                <RecoUI context={context} item={item} />
              )
            }
          </LRTableBodyUI>
        }
      </div>
    </CardUI>

    {
      loan.loanFlavor !== 'small_loan' &&
      <CardUI title='Underwriter to check' className='g_m_bottom_100'>
        <LRTableBodyUI className='g_m_top_100'>
          {
            feasibilityItemList.filter(item => item.flavor === 'classic' && !item.pass && !item.priority && item.recommendation).map((item, i) =>
              < RecoUI context={context} item={item} />
            )
          }
        </LRTableBodyUI>
      </CardUI>
    }

  </div>

const RecoUI = ({ context, item }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={
      <RecoLeftUI context={context} item={item} />
    }
    right={
      <span />
    }
  />

const RecoLeftUI = ({ context, item }) =>
  <div>
    <b>{item.itemName}: </b>
    <span dangerouslySetInnerHTML={{ __html: item.recommendation }} />
  </div>

export default RecommendationUI
